<template>
  <div
    class="im-box"
    :class="{ 'im-box-ar': lang === 'AR' }"
  >
    <div
      ref="refContainer"
      id="IM-container"
    >
    </div>
  </div>
</template>

<script>
import { livechatToken } from '@/api/module/customer'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      token: '',
      refIns: null,
    }
  },
  computed: {
    ...mapGetters(['lang', 'user']),
  },
  watch: {
    user(val) {
      // 退出登录时，销毁创建的IM实例
      if (JSON.stringify(val) === '{}') {
        this.refIns && this.refIns.destroy()
      }
    }
  },
  async mounted() {
    // 先获取token，再创建IM实例
    await this.getToken()
    this.createLivechat()
  },
  methods: {
    // 创建IM实例
    async createLivechat() {
      if (!this.token) return
      const that = this
      that.$nextTick(() => {
        // eslint-disable-next-line no-undef
        this.refIns = livechat.create({
          domElement: document.getElementById('IM-container'),
          accountInfo: {
            token: that.token,
          },
          src: 'https://livechat-jt-sa.airudder.com', // uat: //uat-livechat-jt.airudder.com
          lang: that.lang || 'EN',
          floatButtonProps: { style: { background: 'transparent', 'box-shadow': 'none', right: 30, bottom: 82 }},
          async onAuthError(errMsg) { // 触发此回调说明token已失效，更新token
            console.log('🚀 ~ onAuthError ~ errMsg:', errMsg)
            setTimeout(async () => {
              await that.getToken()
              that.refIns.update('accountInfo', { token: that.token })
            }, 600)
          },
        })
      })
    },
    // 获取IMtoken
    async getToken() {
      const { code, data, msg } = await livechatToken()
      if (code === 1) {
        this.token = data
      } else {
        this.$message.error(msg)
      }
    }
  },
}
</script>

<style lang="scss">
@import './dist/styles/globals.css';

.im-box {
  .css-98ntnt {
    width: 196px;
    height: 60px;
  }
  .livechat-float-btn-body {
    width: 100%;
    height: 100%;
    cursor: pointer;
    background-image: url('../../assets/images/IM-icon.png');
    background-size: cover;
    border-radius: 0 !important;
  }
  .anticon {
    display: none;
  }
}

.im-box-ar {
  .css-98ntnt {
    left: 30px !important;
    right: auto !important;
  }
}
</style>

